var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRocketMobileLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 16,
    viewBox: "0 0 91 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5923 7.62625L62.9171 15.7407H58.3818L52.5897 8.16243V15.7407H48.7852V0.259766H52.5897V7.17545L58.1837 0.259766H62.6951L56.5923 7.62625Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4223 12.5543H75.7854V15.7407H64.6178V0.259766H75.4302V3.44611H68.4223V6.27385H74.7472V9.3714H68.4223V12.5543Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3328 0.259766V3.43927H82.0491V15.7407H85.8399V3.43927H90.5324V0.259766H77.3328Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06724 9.79146L13.7119 15.7407H9.35411L3.80448 8.28196V15.7407H0V0.259766H6.96692C10.283 0.259766 12.6053 2.31569 12.6053 5.28004C12.6053 7.38036 11.2564 9.2826 9.06724 9.79146ZM8.84525 5.32444C8.84525 4.17353 7.93682 3.3778 6.61174 3.3778H3.82497V7.29157H6.61174C7.96073 7.29157 8.84525 6.49584 8.84525 5.32444Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9055 3.33319C25.6956 3.33319 27.8745 5.46766 27.8745 8.40128C27.8745 10.727 26.727 12.1101 25.18 13.1586L27.3042 16C29.9509 14.1968 31.6107 11.6935 31.6107 8.40128C31.6107 3.54493 27.7516 0 22.9055 0C18.0594 0 14.2002 3.54493 14.2002 8.40128C14.2002 11.6935 15.86 14.1968 18.5067 16L20.631 13.1586C19.0805 12.1101 17.9364 10.727 17.9364 8.40128C17.9364 5.46766 20.1153 3.33319 22.9055 3.33319Z",
    fill: "#C7102E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9673 11.4544L46.9618 14.1661C45.5172 15.4536 43.7174 16 41.518 16C37.1637 16 33.407 12.8205 33.407 7.9778C33.407 3.13511 37.1432 0 41.5215 0C43.632 0 45.5206 0.54301 46.9447 1.67684L44.882 4.50117C44.0384 3.83522 43.0549 3.33319 41.5454 3.33319C39.1445 3.33319 37.2115 5.24226 37.2115 8.04269C37.2115 10.8431 39.1445 12.6634 41.6137 12.6634C43.0583 12.6634 44.1067 12.1204 44.9708 11.451",
    fill: "#222222"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRocketMobileLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rocket-mobile-logo.fa6fadb60baaf848f8fac41f63a5ee67.svg";